module.exports = __webpack_public_path__ + "static/media/country-dropdown-footer.ef5a909a.png";